import { render, staticRenderFns } from "./DetailYunyingshangSales.vue?vue&type=template&id=56440863&scoped=true&"
import script from "./DetailYunyingshangSales.vue?vue&type=script&lang=js&"
export * from "./DetailYunyingshangSales.vue?vue&type=script&lang=js&"
import style0 from "./DetailYunyingshangSales.vue?vue&type=style&index=0&id=56440863&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56440863",
  null
  
)

export default component.exports